import * as React from 'react';
import AddUserForm from './../Layout/Form/AddUserForm';
import * as UserModule from 'Modules/UserModule';
import { News } from 'Redux/Actions/Models/ErrorActionModel';
import { setNewsForMoment } from 'Redux/Actions/ErrorActions';
import { connect } from 'react-redux';
import * as Dictionary from 'Models/Dictionary';
import { withTranslation  } from 'react-i18next';
import { RootState } from 'Redux/Reducers/_RootReducer';
import {getVoivodeships} from "Redux/Actions/UserActions";
import {prepareCounties, prepareVoivodeships} from "components/Layout/Form/AddUserForm.Services";

type Props = {
    history?: any;
    match: any;
};

type ConnectedDispatch = {
    updateUser: Function;
    getUserById: (userId: number) => Function;
    setNews: (news: News) => Function;
    clearStatus: () => Function;
    setActiveUser: (userObj: UserModule.Types.UserDto) => Function;
    getVoivodeships: () => Promise<void>;
};

type ConnectedProps = {
    t: Function;
    userStore: UserModule.Types.UserStore;
};

type State = {};

class UserManagementEdit extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async componentDidMount() {
        if (this.props.match.params.userId) {
            await this.props.getUserById(this.props.match.params.userId);
        }
        this.props.getVoivodeships()
    }

    public async handleSubmit({ provinces, counties, ...formData}: any) {
      const { updateUser } = this.props;
      const mappedProvinces = formData?.roleName?.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
        ? provinces.map(({ value }) => value)
        : undefined

      const mappedCounties = formData?.roleName?.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
        ? counties.map(({ value }) => value)
        : undefined
        const newUserData: UserModule.Types.CreateUserAccountForm = {
          ...formData,
          provinces: mappedProvinces,
          countyIds: mappedCounties
        };
        await updateUser(this.props.match.params.userId, newUserData);
    }

    public render() {
        let initialValues = {};
        const options = Dictionary.GenerateList(Dictionary.RoleNameArray);
        if (this.props.userStore.activeUser) {
            initialValues = {
                ...this.props.userStore.activeUser,
                roleName: options.find((e, i) => e.value === this.props.userStore.activeUser.roleName),
                provinces: prepareVoivodeships(this.props.userStore.activeUser.provinces),
                counties: prepareCounties(this.props.userStore.activeUser.counties),
            };
        }

        return (
            <div className="main__content main__content--scroll">
                <AddUserForm
                    initialValues={initialValues}
                    onSubmit={this.handleSubmit}
                    {...{
                        typeForm: 'edit'
                    }}
                />
            </div>
        );
    }

    public componentWillUnmount() {
        this.props.setActiveUser(null);
    }
}

function mapStateToProps(state: RootState) {
    return {
        userStore: state.userStore
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        updateUser: (userId: number, formData: UserModule.Types.CreateUserAccountForm) => dispatch(UserModule.Actions.updateUser(userId, formData)),
        clearStatus: () => dispatch(UserModule.Actions.clearCreateUserStatus()),
        setNews: (news: News) => dispatch(setNewsForMoment(news)),
        getUserById: (userId: number) => dispatch(UserModule.Actions.getUserById(userId)),
        setActiveUser: (userDto: UserModule.Types.UserDto) => dispatch(UserModule.Actions.setActiveUser(userDto)),
        getVoivodeships: () => dispatch(getVoivodeships()),
    };
}

export default withTranslation (['forms', 'errors', 'dictionary'])(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserManagementEdit) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/UserManagement/UserManagementEdit.tsx